import {
  EDITOR_LOAD_INSTALLED_PLUGINS_BEGIN,
  EDITOR_LOAD_INSTALLED_PLUGINS_DISMISS_ERROR,
  EDITOR_LOAD_INSTALLED_PLUGINS_FAILURE,
  EDITOR_LOAD_INSTALLED_PLUGINS_SUCCESS,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadInstalledPlugins(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_INSTALLED_PLUGINS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/plugins/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_INSTALLED_PLUGINS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_INSTALLED_PLUGINS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadInstalledPluginsError() {
  return {
    type: EDITOR_LOAD_INSTALLED_PLUGINS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_INSTALLED_PLUGINS_BEGIN:
      return {
        ...state,
        loadInstalledPluginsPending: true,
        loadInstalledPluginsError: null,
      };

    case EDITOR_LOAD_INSTALLED_PLUGINS_SUCCESS:
      return {
        ...state,
        loadInstalledPluginsPending: false,
        loadInstalledPluginsError: null,
        plugins: action.data,
      };

    case EDITOR_LOAD_INSTALLED_PLUGINS_FAILURE:
      return {
        ...state,
        loadInstalledPluginsPending: false,
        loadInstalledPluginsError: action.data.error,
      };

    case EDITOR_LOAD_INSTALLED_PLUGINS_DISMISS_ERROR:
      return {
        ...state,
        loadInstalledPluginsError: null,
      };

    default:
      return state;
  }
}
